var $081d502afa41074a$exports = {};
$081d502afa41074a$exports = {
    "valid": `Giltig`
};


export {$081d502afa41074a$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
